import styled from 'styled-components';

export const FlagLabel = styled.div`
  position: absolute;
  padding: 0 2rem;
  color: ${({ theme }) => theme.UI_COLORS.light};
  background-color: ${({ theme }) => theme.UI_COLORS.label};
  height: 2.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${({ theme }) => theme.TYPOGRAPHY.label.fontSize};
  font-weight: ${({ theme }) => theme.TYPOGRAPHY.label.fontWeight};
  right: -20px;
  top: 40px;
  transform: rotate(-90deg);

  &:before {
    content: '';
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 1.1rem 1.1rem 1.1rem;
    border-color: transparent transparent ${({ theme }) =>
      theme.UI_COLORS.light} transparent;
    position: absolute;
    left: -0.6rem;
    transform: rotate(90deg);
  }

  &:after {
    content: '';
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 0.5rem 0.6rem 0.5rem;
    border-color: transparent transparent ${({ theme }) =>
      theme.UI_COLORS.labelShadow} transparent;
    position: absolute;
    right: 0.1rem;
    bottom: -0.5rem;
    transform: rotate(-45deg);
  }
}
`;
